import { currentUrl, URLX, pushState } from '@avensia/excite';
import { SEARCH_PARAMS_PAGE } from '@avensia/excite-esales';

const URL_PARAM_CLEAN = 'clean';
const URL_PARAM_SCROLL = 'scroll';

export function getPaginationUrl(page: number): URLX {
  const url = currentUrl();
  url.searchParams.delete(URL_PARAM_CLEAN);
  url.searchParams.delete(URL_PARAM_SCROLL);
  url.searchParams.delete(SEARCH_PARAMS_PAGE);
  if (page > 1) {
    url.searchParams.append(SEARCH_PARAMS_PAGE, String(page));
  }

  return url;
}

export function updateUrlWithPaginationSearchParams(currentPage: number) {
  return pushState(getPaginationUrl(currentPage), { skipUpdateScrollPosition: true });
}
